
import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Clock } from 'lucide-react';

interface DelayNodeProps {
  data: {
    label: string;
    description?: string;
    config?: {
      delay?: number;
      unit?: 'minutes' | 'hours' | 'days';
    }
  };
  selected: boolean;
}

export const DelayNode: React.FC<DelayNodeProps> = ({ data, selected }) => {
  const delay = data.config?.delay || 0;
  const unit = data.config?.unit || 'minutes';
  
  return (
    <div className={`p-3 rounded-md border-2 ${selected ? 'border-primary' : 'border-border'} bg-card shadow-sm min-w-[180px]`}>
      <div className="flex items-center gap-2 font-medium text-sm mb-1">
        <Clock className="w-4 h-4 text-orange-500" />
        {data.label}
      </div>
      
      <p className="text-xs text-muted-foreground">
        Espera: {delay} {unit}
      </p>
      
      <Handle
        type="target"
        position={Position.Top}
        id="in"
        className="w-3 h-3 bg-muted-foreground border-2 border-background"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="out"
        className="w-3 h-3 bg-primary border-2 border-background"
      />
    </div>
  );
};
